$mol_link_donate $mol_link
	hint @ \Thank with a dollar
	sub /
		<= Icon $mol_icon_gift_outline
